export default class Lagerbuchungsart {
    public lagerbuchungsart: string | null = null;
    public beschreibung: string | null = null;
    public gueltig: string | null = null;
    public zeitstempel: string | null = null;

    public static readonly Default = 'Zugang';

    constructor(data?: Partial<Lagerbuchungsart>) {
        Object.assign(this, data);
    }
}
